var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"plugin-home-hero-item"},[_c('div',{staticClass:"plugin-home-hero-item__title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"plugin-home-hero-item__description"},[_vm._v(_vm._s(_vm.description))])])}
var staticRenderFns = []

export { render, staticRenderFns }